<section
  id="main"
  class="c-row--main row center">
  <div class="col-12">
    <div class="o-grid">
      <div class="o-grid__item col-12">
        <h1>{{ localizationConstants.TOOL_SEARCH_TITLE | translate }}</h1>
        <a
          (click)="modalService.close()"
          class="modal-button__close">
          <mat-icon svgIcon="close-dark"></mat-icon>
        </a>
      </div>
      <div class="o-grid__item col-12">
        <form
          #f="ngForm"
          class="c-search-filter-form"
          (ngSubmit)="onSubmit()">
          <div class="c-input-group">
            <input
              type="text"
              name="search"
              id="main-search"
              [(ngModel)]="quickSearch"
              class="c-input c-input--alpha c-input--main"
              placeholder="{{ localizationConstants.HOME_SEARCH_BY | translate }}"
              [disabled]="!companyService.selectedCompany" />
            <button
              *ngIf="!quickSearch"
              id="tools-search"
              type="submit"
              class="c-button c-button--search"
              value="Search"></button>
            <button
              *ngIf="quickSearch"
              id="tools-search"
              type="button"
              class="c-button c-button--search c-close-search"
              (click)="quickSearch = ''"
              value="Search"></button>
          </div>
        </form>
      </div>
      <!-- TODO: Add isLoading state to httpInterceptor -->
      <div
        *ngIf="isLoading"
        class="o-grid__item col-12 u-mt--large last">
        <app-loading-icon
          class="u-color--light"
          size="2x"></app-loading-icon>
      </div>
      <div class="o-grid__item col-12">
        <div class="u-scroll--horizontal">
          <div
            [hidden]="isLoading"
            id="c-tools-table"
            class="c-tools-table">
            <div class="c-tools-counter">
              {{
                toolsTotal > 0
                  ? toolsTotal + " " + (localizationConstants.HOME_RESULTS | translate)
                  : (localizationConstants.TABLE_NO_RESULTS | translate)
              }}
            </div>
            <table
              [hidden]="!toolsTotal"
              class="c-table"
              matSort
              mat-table
              [dataSource]="dataSource">
              <ng-container
                *ngFor="let col of columns"
                [matColumnDef]="col.key">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header>
                  {{ col.title | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let row"
                  class="c-clickable"
                  (click)="redirectTo(row.companyId, row.serialNumber)">
                  <span>{{ row[col.key] }}</span>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="columnKeys"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: columnKeys"
                class="c-table__row"></tr>
            </table>
            <div
              [hidden]="!toolsTotal"
              class="c-pagination--container center">
              <div class="col-12">
                <mat-paginator
                  [showFirstLastButtons]="true"
                  [pageSize]="pageSize"
                  [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
